import Header from "./Index";


export default function Home () {
    return (
        <div>
            <Header />
            {/* <h2>Welcome to the Home Page :)</h2>
            <a href="/about" >Click to go to About Page</a>
            <br />
            <br />
            <br />
            <a href="/auth/signIn" >Click to go to Sign In Page</a>
            <br />
            <br />
            <a href="/auth/signUp" >Click to go to Sign Up Page</a>
            <br />
            <br />
            <a href="/dashboard" >Click to go to Dashboard Page</a> */}
        </div>
    )
}